<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M33.9389 10.748H15.7569C13.7489 10.748 12.1211 12.4313 12.1211 14.5077V37.07C12.1211 39.1464 13.7489 40.8296 15.7569 40.8296H33.9389C35.9469 40.8296 37.5747 39.1464 37.5747 37.07V14.5077C37.5747 12.4313 35.9469 10.748 33.9389 10.748Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M35.1021 10.4681H14.5938L16.4587 3H33.2386L35.1021 10.4681Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M35.2593 40.8301H14.4336L16.3274 47.0007H33.367L35.2593 40.8301Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M37.8984 14.2809L38.7919 14.2426C39.837 14.2205 40.6951 15.0621 40.6951 16.1085V19.8035C40.6951 20.8352 39.8605 21.6709 38.8302 21.6709H37.8984"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.7967 14.2809L10.9032 14.2426C9.85813 14.2205 9 15.0621 9 16.1085V19.8035C9 20.8352 9.83458 21.6709 10.8649 21.6709H11.7967"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M37.8984 36.5267L38.7919 36.565C39.837 36.5871 40.6951 35.7455 40.6951 34.6991V31.0041C40.6951 29.9724 39.8605 29.1367 38.8302 29.1367H37.8984"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.7967 36.5267L10.9032 36.565C9.85813 36.5871 9 35.7455 9 34.6991V31.0041C9 29.9724 9.83458 29.1367 10.8649 29.1367H11.7967"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M32.5613 13.834H17.1358C16.0706 13.834 15.207 14.7263 15.207 15.8271V35.7519C15.207 36.8526 16.0706 37.745 17.1358 37.745H32.5613C33.6265 37.745 34.4901 36.8526 34.4901 35.7519V15.8271C34.4901 14.7263 33.6265 13.834 32.5613 13.834Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M24.8477 19.8027V25.4034L29.5078 30.0711"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
